import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const enModules = import.meta.glob("./locales/en/*.json", { eager: true });
const arModules = import.meta.glob("./locales/ar/*.json", { eager: true });
const hiModules = import.meta.glob("./locales/hi/*.json", { eager: true });
const mlModules = import.meta.glob("./locales/ml/*.json", { eager: true });
const frModules = import.meta.glob("./locales/fr/*.json", { eager: true });
const esModules = import.meta.glob("./locales/es/*.json", { eager: true });

function formatLocaleBundle(modules: Record<string, any>) {
  const bundle: Record<string, any> = {};
  for (const path in modules) {
    const key = path.split("/").pop()!.replace(".json", "");
    bundle[key] = (modules[path] as any).default || modules[path];
  }
  return bundle;
}

const en = formatLocaleBundle(enModules);
const ar = formatLocaleBundle(arModules);
const hi = formatLocaleBundle(hiModules);
const ml = formatLocaleBundle(mlModules);
const fr = formatLocaleBundle(frModules);
const es = formatLocaleBundle(esModules);

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", flag: "🇺🇸", dir: "ltr" },
  { code: "ar", label: "العربية", flag: "🇦🇪", dir: "rtl" },
  { code: "hi", label: "हिन्दी", flag: "🇮🇳", dir: "ltr" },
  { code: "ml", label: "മലയാളം", flag: "🇮🇳", dir: "ltr" },
  { code: "fr", label: "Français", flag: "🇫🇷", dir: "ltr" },
  { code: "es", label: "Español", flag: "🇪🇸", dir: "ltr" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      hi: { translation: hi },
      ml: { translation: ml },
      fr: { translation: fr },
      es: { translation: es },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

// Automatically handle RTL layout direction on language switch
i18n.on("languageChanged", (lng) => {
  // i18next-browser-languagedetector might return subcodes like 'en-US', handle prefix matching
  const shortCode = lng.split("-")[0];
  const langConfig = SUPPORTED_LANGUAGES.find((l) => l.code === shortCode) || SUPPORTED_LANGUAGES[0];
  const dir = langConfig.dir || "ltr";
  document.documentElement.dir = dir;
  document.documentElement.lang = langConfig.code;
});

// Run direction switch immediately on load based on resolved language
const currentLng = i18n.language || "en";
const shortCode = currentLng.split("-")[0];
const initialConfig = SUPPORTED_LANGUAGES.find((l) => l.code === shortCode) || SUPPORTED_LANGUAGES[0];
document.documentElement.dir = initialConfig.dir;
document.documentElement.lang = initialConfig.code;

export default i18n;
